import ServiceLocator from "../../../../shared/service-locator"
import { useEffect, useState } from "react"
import { FormattedSuspectSectionDetails } from "../../../../shared/utils/format-section-details.util"

const reviewerReportDetailsService = ServiceLocator.instance.reviewerReportDetailsService
const suspectSectionDetailsService = ServiceLocator.instance.suspectSectionDetailsService

export function useSuspectSectionDetailsController() {

  const [ sectionDetails, setSectionDetails ] = useState<FormattedSuspectSectionDetails>(suspectSectionDetailsService.suspectSectionDetails)

  useEffect(() => {

    const reviewerReportId = reviewerReportDetailsService.targetReviewerReportId

    const reviewerStatusUpdateSubscription = reviewerReportDetailsService.subscribeToReviewerReportDetailsSummaryUpdate(() => {
      if (reviewerReportId) {
        suspectSectionDetailsService.getSuspectSectionDetails(reviewerReportId)
      }
    })

    const subscription = suspectSectionDetailsService.subscribeToSuspectSectionDetailsUpdate(() => {
      const suspectSectionDetails = suspectSectionDetailsService.suspectSectionDetails
      setSectionDetails(suspectSectionDetails)
    })

    if (reviewerReportId) {
      suspectSectionDetailsService.getSuspectSectionDetails(reviewerReportId)
    }

    return () => {
      subscription.cancel()
      reviewerStatusUpdateSubscription.cancel()
    }
  }, [])

  return {
    sectionDetails
  }
}
